export const effectiveDoctorTypeGapProvider = 'X';
export const commercialGapProgramTypeCode = 'B';
